// Dados de contato centralizados — reutilizados em CTAs, header, footer, etc.
export const WHATSAPP_NUMBER = '5511974512072';
export const WHATSAPP_DISPLAY = '+55 11 97451-2072';

// Link do WhatsApp com mensagem opcional pré-preenchida.
export const waLink = (message = 'Olá! Quero saber mais sobre a CoreDesk.') =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const WHATSAPP_URL = waLink();
